import React, { Component } from 'react'
import { withRouter } from 'react-router-dom'
import CacheKeys from '../../../cache/CacheKeys'
import CacheManager from '../../../cache/CacheManager'
import RestApiUtils from '../../../apiclient/moebli/RestApiUtils'
import DocumentRepositoryPageUI from './DocumentRepositoryPageUI.js'
class DocumentRepositoryPageSF extends Component {
  constructor(props) {
    super(props)
    this.state = {
      errorList: null,
      loan: null,
      categoryList: null,
      uploadCategory: null,
      downloadingKey: null
    }
  }

  render() {
    return (
      <DocumentRepositoryPageUI
        context={this.props.context}
        errorList={this.state.errorList}
        loan={this.state.loan}
        categoryList={this.state.categoryList}
        onRefreshClick={this.onRefreshClick}
        downloadingKey={this.state.downloadingKey}
        uploadCategory={this.state.uploadCategory}
        onUploadClick={this.onUploadClick}
        onCancelUpload={this.onCancelUpload}
        onUpload={this.onUpload}
        onDownloadClick={this.onDownloadClick}
        onDownloadSectionClick={this.onDownloadSectionClick}
        onDownloadLoanClick={this.onDownloadLoanClick}
        onDeleteClick={this.onDeleteClick}
      />
    )
  }

  componentDidMount() {
    let context = this.props.context
    this.getLoan(context)
  }

  getLoan(context) {
    let cacheManager = new CacheManager({
      resource: `/api/su/loans/${this.props.match.params.loanId}`,
      cacheKey: CacheKeys.Loan(this.props.match.params.loanId),
      callback: this.getLoanCallback,
      ttlInSecs: 600
    })
    cacheManager.getObject2(context)
  }

  getLoanCallback = (response) => {
    if (response.loan && response.loan.parentLoanId) {
      this.props.history.replace(`/su/documentRepository/loans/${response.loan.parentLoanId}`)
      return
    }
    this.setState({ errorList: response.errorList, loan: response.loan })
    this.getDocumentRepository(this.props.context)
  }

  getDocumentRepository(context) {
    let cacheManager = new CacheManager({
      resource: `/api/su/loans/${this.props.match.params.loanId}/documentRepository`,
      cacheKey: CacheKeys.DocumentRepository(this.props.match.params.loanId),
      callback: this.getDocumentRepositoryCallback,
      ttlInSecs: 600
    })
    cacheManager.getObject2(context)
  }

  getDocumentRepositoryCallback = (response) => {
    this.setState({ errorList: response.errorList, categoryList: response.categoryList })
  }
  onUploadClick = (category) => {
    this.setState({ uploadCategory: category })
  }

  onCancelUpload = () => {
    this.setState({ uploadCategory: null })
  }

  onUpload = (fileId, fileName, fileType, fileSize) => {
    let context = this.props.context
    let category = this.state.uploadCategory
    let finalizeUrl = category === 'underwriting'
      ? `/api/su/loans/${this.props.match.params.loanId}/documentRepository/creditMemo/finalizeUpload?fileId=${fileId}`
      : `/api/su/loans/${this.props.match.params.loanId}/documentRepository/${category}/finalizeUpload?fileId=${fileId}`
    let putResource = `${RestApiUtils.getServerUrl(context)}${finalizeUrl}`

    fetch(putResource, {
      method: 'post',
      headers: RestApiUtils.getHeaders(context),
    })
      .then((response) => response.json())
      .then((json) => {
        this.setState({ uploadCategory: null })
        this.onRefreshClick()
      })
  }

  onDownloadClick = (category, file) => {
    if (this.state.downloadingKey)
      return
    let context = this.props.context

    if (file.fileCode === 'mca_certificates_folder' || file.fileCode === 'mca_incorporation_documents_folder') {
      let folderKey = file.fileCode === 'mca_certificates_folder' ? 'certificates' : 'incorporation_documents'
      let getResource = `${RestApiUtils.getServerUrl(context)}/api/su/loans/${this.props.match.params.loanId}/documentRepository/kyc/downloadMcaFolder?folderKey=${folderKey}`

      this.setState({ downloadingKey: `mca:${folderKey}` })
      fetch(getResource, { headers: RestApiUtils.getHeaders(context) })
        .then((response) => response.blob())
        .then((blob) => {
          const url = window.URL.createObjectURL(blob)
          const link = document.createElement('a')
          link.href = url
          link.download = `${folderKey}.zip`
          document.body.appendChild(link)
          link.click()
          document.body.removeChild(link)
          window.URL.revokeObjectURL(url)
        })
        .finally(() => this.setState({ downloadingKey: null }))
      return
    }

    if (file.fileCode && file.fileCode.startsWith('manual_zip_folder:')) {
      let subfolder = file.fileCode.substring('manual_zip_folder:'.length)
      let getResource = `${RestApiUtils.getServerUrl(context)}/api/su/loans/${this.props.match.params.loanId}/documentRepository/${category}/downloadManualFolder?subfolder=${encodeURIComponent(subfolder)}`

      this.setState({ downloadingKey: `manual:${subfolder}` })
      fetch(getResource, { headers: RestApiUtils.getHeaders(context) })
        .then((response) => response.blob())
        .then((blob) => {
          const url = window.URL.createObjectURL(blob)
          const link = document.createElement('a')
          link.href = url
          link.download = `${subfolder}.zip`
          document.body.appendChild(link)
          link.click()
          document.body.removeChild(link)
          window.URL.revokeObjectURL(url)
        })
        .finally(() => this.setState({ downloadingKey: null }))
      return
    }

    let params = `category=${category}&fileName=${encodeURIComponent(file.fileName)}` + `&manuallyUploaded=${!!file.manuallyUploaded}` + (file.fileCode ? `&fileCode=${file.fileCode}` : '') +
      (file.userId ? `&userId=${file.userId}` : '')
    let getResource = `${RestApiUtils.getServerUrl(context)}/api/su/loans/${this.props.match.params.loanId}/documentRepository/download?${params}`

    fetch(getResource, { headers: RestApiUtils.getHeaders(context) })
      .then((response) => response.json())
      .then((json) => {
        if (json.signedUrl && json.signedUrl.signedUrl) {
          const link = document.createElement('a')
          link.href = json.signedUrl.signedUrl
          document.body.appendChild(link)
          link.click()
          document.body.removeChild(link)
        }
      })
  }

  onDownloadSectionClick = (category) => {
    if (this.state.downloadingKey)
      return
    let context = this.props.context
    let getResource = `${RestApiUtils.getServerUrl(context)}/api/su/loans/${this.props.match.params.loanId}/documentRepository/${category}/downloadSection`

    this.setState({ downloadingKey: `section:${category}` })
    fetch(getResource, { headers: RestApiUtils.getHeaders(context) })
      .then((response) => response.blob())
      .then((blob) => {
        const url = window.URL.createObjectURL(blob)
        const link = document.createElement('a')
        link.href = url
        link.download = `${category}.zip`
        document.body.appendChild(link)
        link.click()
        document.body.removeChild(link)
        window.URL.revokeObjectURL(url)
      })
      .finally(() => this.setState({ downloadingKey: null }))
  }

  onDownloadLoanClick = () => {
    let context = this.props.context
    let getResource = `${RestApiUtils.getServerUrl(context)}/api/su/loans/${this.props.match.params.loanId}/documentRepository/downloadLoan`

    fetch(getResource, { headers: RestApiUtils.getHeaders(context) })
      .then((response) => response.blob())
      .then((blob) => {
        const url = window.URL.createObjectURL(blob)
        const link = document.createElement('a')
        link.href = url
        link.download = 'loan_documents.zip'
        document.body.appendChild(link)
        link.click()
        document.body.removeChild(link)
        window.URL.revokeObjectURL(url)
      })
  }

  onDeleteClick = (category, file) => {
    if (!window.confirm(`Delete ${file.fileName}?`))
      return
    let context = this.props.context

    let deleteResource = `${RestApiUtils.getServerUrl(context)}/api/su/loans/${this.props.match.params.loanId}/documentRepository/${category}/delete?fileName=${encodeURIComponent(file.fileName)}`
    fetch(deleteResource, {
      method: 'post',
      headers: RestApiUtils.getHeaders(context),
    })
      .then((response) => response.json())
      .then((json) => {
        this.onRefreshClick()
      })
  }
  onRefreshClick = () => {
    let context = this.props.context
    CacheManager.removeObject(CacheKeys.Loan(this.props.match.params.loanId))
    CacheManager.removeObject(CacheKeys.DocumentRepository(this.props.match.params.loanId))
    this.setState({ loan: null, categoryList: null, errorList: null })
    this.getLoan(context)
  }
}

export default withRouter(DocumentRepositoryPageSF)